const subcontractorBasePath = '/subcontractors';

const SubcontractorConst = {
    basePath : subcontractorBasePath
};

export default SubcontractorConst;